import {
	DateEntityAttribute,
	Entity,
	IntegerEntityAttribute,
	StringEntityAttribute,
	EntityListEntityAttribute
} from '../base/Entity';

/**
 * @name Soundtrack
 * @property {Number} Id
 * @property {Number} Order
 * @property {String} Name
 * @property {Date} Date
 *
 * @property {Object} Tracks
 * @property {Object} Links
 *
 * @property {String} ImageUrl
 */
export class Soundtrack extends Entity {
}

Soundtrack.Register('Soundtrack');
Soundtrack.Attributes = [
	new IntegerEntityAttribute('Id'),
	new IntegerEntityAttribute('Order'),
	new StringEntityAttribute('Name'),
	new DateEntityAttribute('Date'),

	new EntityListEntityAttribute('Tracks', SoundtrackTrack, true),
	new EntityListEntityAttribute('Links', SoundtrackLink, true),

	new StringEntityAttribute('ImageUrl'),
];

export default Soundtrack;

/**
 * @name SoundtrackTrack
 * @property {Number} Id
 * @property {Number} Number
 * @property {String} Name
 * @property {String} Artists
 * @property {String} Length
 * @property {String} Lyrics
 */
export class SoundtrackTrack extends Entity {}

SoundtrackTrack.Register('SoundtrackTrack');
SoundtrackTrack.Attributes = [
	new IntegerEntityAttribute('Id'),
	new IntegerEntityAttribute('Number'),
	new StringEntityAttribute('Name'),
	new StringEntityAttribute('Artists'),
	new StringEntityAttribute('Length'),
	new StringEntityAttribute('Lyrics')
];

/**
 * @name SoundtrackLink
 * @property {Number} Id
 * @property {Number} Order
 * @property {String} Name
 * @property {String} Url
 */
export class SoundtrackLink extends Entity {}

SoundtrackLink.Register('SoundtrackLink');
SoundtrackLink.Attributes = [
	new IntegerEntityAttribute('Id'),
	new IntegerEntityAttribute('Order'),
	new StringEntityAttribute('Name'),
	new StringEntityAttribute('Url')
];
